import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { styles } from "./CsvExportButton.styles";
import { CSVLink } from "react-csv";

export interface IColumnMapping {
    label: string,
    key: string,
    mappingFunc?: Function
}

interface ICsvExportButtonProps extends WithStyles<typeof styles> {
    children?: React.ReactNode,
    outputFilename: string,
    data: any, // array of objects, any type
    mappings?: IColumnMapping[], // keys must match property names of objects in data
}

const CsvExportButtonPure: React.FunctionComponent<ICsvExportButtonProps> = ({
                                                                                 data,
                                                                                 children,
                                                                                 outputFilename,
                                                                                 mappings,
                                                                                 classes
                                                                             }: ICsvExportButtonProps) => {

    let headersToPass = mappings;
    // copy the data, otherwise they would be modified
    let dataToPass = data.map(d => ({...d})); 
    if (data.length > 0) {

        if (!mappings) {
            // get rid of technical fields in advance
            let keys = Object.keys(data[0]).filter(e => e !== "sjsId" && e !== "sjsOptions");
            headersToPass = keys.map(k => {
                return {label: k, key: k};
            });
        } else {
            mappings.filter(m => m.mappingFunc).forEach(m => {
                dataToPass.forEach(e => e[m.key] = m.mappingFunc(e[m.key]));
            });
        }
    }

    return (
        <div className={classes.buttonOuter}>
            <CSVLink
                data={dataToPass}
                headers={headersToPass}
                filename={outputFilename}
                className={classes.button}
                target="_blank">
                {children}
            </CSVLink>
            </div>
    );
};

export const CsvExportButton = withStyles(styles)(CsvExportButtonPure);
